import { type Market } from './marketIndicator';

// The zone each panel's dates render in when a record has no «buzón» to borrow one from — today
// only the carrier exclusion lists' «Desde». The Spanish panel shows Madrid time, the UK panel London
// time; the non-production environments run on ES data.
const MARKET_TIME_ZONES: Record<Market, string> = {
  es: 'Europe/Madrid',
  uk: 'Europe/London',
  sandbox: 'Europe/Madrid',
  dev: 'Europe/Madrid',
};

// `null` in, `null` out: a panel that cannot name its country must not quietly become Madrid.
export function marketTimeZone(market: Market | null): string | null {
  return market === null ? null : MARKET_TIME_ZONES[market];
}
